/*
 * An address inside the signed-in app that no route answers (App.js's
 * catch-all). It says so, shows the address and leads Home, inside the menus,
 * so nobody lands on a blank page from an old link or a typo.
 */
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { PageNotice } from '../components/RequireScope';

export default function NotFound() {
  const { t } = useTranslation('hubs');
  const { pathname } = useLocation();
  return (
    <PageNotice testId="not-found" title={t('notFound.title')} homeLabel={t('notFound.home')}
      reportLabel={t('notFound.report')}>
      <p>
        {t('notFound.body')} <code dir="ltr" data-testid="not-found-path">{pathname}</code>
      </p>
      <p className="page-notice-help">{t('notFound.help')}</p>
    </PageNotice>
  );
}
